
  import Vue from "vue";
  import PwaChatContainer from "@/components/chat/PwaChatContainer.vue";

  import { CHAT_TYPES } from "@/services/chat";
  import pageMixin from "@/mixins/page";
  import { ROUTES } from '@/router/routes';

  export default Vue.extend({
    name: "MessagesUser",
    mixins: [pageMixin],
    components: {
      PwaChatContainer,
    },
    mounted(): void {
      this.checkDevice();
    },
    data() {
      return {
        chatData: null,
      }
    },
    computed: {
      username(): string {
        return this.$route.params.username;
      },
    },
    methods: {
      async checkDevice() {
        if (this.isDesktop) {
          await this.$router.replace({name: ROUTES.messages.name, hash: ('#' + encodeURIComponent(this.username)), params: {lang: this.routeLang}});
        }else {
          await this.getChatData();
        }
      },
      async getChatData() {
        try {
          this.showLoader(true);
          const {data} = await this.$http.user.getChatData(CHAT_TYPES.USERS, {
            username: this.username,
            addDescription: 1
          });
          this.chatData = data.data;
        } catch (e) {
          this.showToastError(this.$t('139'), this.$t('140'));
        } finally {
          this.showLoader(false);
        }
      },
      goToUserProfile(username: string) {
        this.$router.push({name: ROUTES.profile.name, params: {lang: this.routeLang, username}});
      }
    },
    watch: {
      username() {
        this.getChatData();
      },
    }
  });
